console.log("global");
jQuery(document).ready(function($) {

    // Hover Section Toggle - Click only
    $('.hover-container').each(function() {
        const $container = $(this);
        const $hoverSection = $container.find('.ct-more-hover-section');
        const $moreMark = $container.find('.ct-more-hover .gspb_iconsList__item__text mark:nth-child(2)');
        
        if ($hoverSection.length === 0) return;
        
        // Click event on the "more" mark to toggle
        $moreMark.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $hoverSection.toggleClass('active');
        });
    });
    
    // Hide when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.hover-container').length) {
            $('.ct-more-hover-section').removeClass('active');
        }
    });
    
    // Image Zoom Functionality
    $('.image-zoom-container').each(function() {
        const $container = $(this);
        const $img = $container.find('img');
        const $zoomIcons = $container.find('.zoom-icon');
        let isZoomed = false;
        let currentZoomIcon = null;
        
        // Click on zoom icon
        $zoomIcons.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const $clickedIcon = $(this);
            
            if (!isZoomed || currentZoomIcon !== $clickedIcon[0]) {
                // Zoom in to specific area
                $container.addClass('zoomed');
                isZoomed = true;
                currentZoomIcon = $clickedIcon[0];
                
                // Get icon position as percentages from style attribute
                const iconStyle = $clickedIcon.attr('style');
                const topMatch = iconStyle.match(/top:\s*([0-9.]+)%/);
                const leftMatch = iconStyle.match(/left:\s*([0-9.]+)%/);
                
                const iconTop = topMatch ? parseFloat(topMatch[1]) : 50;
                const iconLeft = leftMatch ? parseFloat(leftMatch[1]) : 50;
                
                // Zoom to the specific area where the icon is located
                $img.css({
                    'transform': 'scale(2)',
                    'transform-origin': `${iconLeft}% ${iconTop}%`
                });
            } else {
                // Zoom out
                $container.removeClass('zoomed');
                isZoomed = false;
                currentZoomIcon = null;
                $img.css({
                    'transform': 'scale(1)',
                    'transform-origin': 'center center'
                });
            }
        });
        
        // Click on image to zoom out
        $img.on('click', function(e) {
            if (isZoomed) {
                e.preventDefault();
                e.stopPropagation();
                $container.removeClass('zoomed');
                isZoomed = false;
                currentZoomIcon = null;
                $img.css({
                    'transform': 'scale(1)',
                    'transform-origin': 'center center'
                });
            }
        });
    });
    
    // Close zoom when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.image-zoom-container').length) {
            $('.image-zoom-container').removeClass('zoomed');
        }
    });
    
    // Escape key to close zoom
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $('.image-zoom-container').removeClass('zoomed');
        }
    });
    
    // Hide when pressing Escape key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $('.ct-more-hover-section').removeClass('active');
        }
    });

    // Search Popup
    $('.search-icon-h').on('click', function() {
        $('.search-form').addClass('active');
    });

    $('#close-search-form').on('click', function() {
        $('.search-form').removeClass('active');
    });

    // Mobile Menu
    $('.menu-toggle-icon').on('click', function() {
        let $menu = $('.main-menu-section');
        let $body = $('body');

        $menu.toggleClass('active-menu');
        $body.toggleClass('body-scroll-disable');
    });

    // Close the menu when clicking outside of .main-menu-section
    $(document).on('click', function(event) {
        let $menu = $('.main-menu-section');
        let $menuToggle = $('.menu-toggle-icon');

        // Check if the click is outside the menu and the menu toggle icon
        if (!$(event.target).closest($menu).length && !$(event.target).closest($menuToggle).length) {
            // Close the menu if outside click
            $menu.removeClass('active-menu');
            $('body').removeClass('body-scroll-disable');
        }
    });

    function equalizeProductCardSlides($slider) {
        const $cards = $slider.find('.slick-slide .product-slide-inner');
        $cards.css('height', '');

        if (window.innerWidth < 975) {
            return;
        }

        let maxHeight = 0;
        $cards.each(function () {
            maxHeight = Math.max(maxHeight, this.offsetHeight);
        });

        if (maxHeight > 0) {
            $cards.css('height', maxHeight);
        }
    }

    function initializeSlickSlider() {
        if ($('.product-slider.slides-card').length) {
            const $productSlider = $('.product-slider.slides-card');

            $productSlider.on('setPosition', function () {
                equalizeProductCardSlides($(this));
            });

            $productSlider.slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                speed: 500,
                arrows: true,
                dots: true,
                centerPadding: '0px',
                cssEase: 'ease',
                prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div></div>',
                nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

        if ($('.testimonials-slider').length) {
            $('.testimonials-slider').slick({
                infinite: true,
                focusOnSelect: true,
                slidesToShow: 1,  // Show one slide at a time
                speed: 500,
                arrows: true,
                dots: true,  // Show dots for navigation
                prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div>',
                nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                centerPadding: '0px',  // Adjust the space around the center slide
                cssEase: 'ease',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                        }
                    }
                ]
            });
        }

        const $carouselWrapper = $('.news-events-carousel-wrapper');
        const $carouselItems = $carouselWrapper.find('.uagb-post__inner-wrap');

        if ($carouselItems.length > 3) {
            $carouselWrapper.addClass('is-carousel');
        } else {
            $carouselWrapper.addClass('is-simple');
        }

        if ($('.news-events-carousel-wrapper').length) {
            $('.news-events-carousel-wrapper').slick({
                infinite: false,
                focusOnSelect: true,
                slidesToShow: 3,
                speed: 500,
                arrows: false,
                dots: true,
                centerPadding: '0px',
                cssEase: 'ease',
                prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div>',
                nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                responsive: [
                    {
                        breakpoint: 976,
                        settings: {
                            slidesToShow: 2.4,
                            arrows: true,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1.4,
                            arrows: true,
                        }
                    },
                    {
                        breakpoint: 430,
                        settings: {
                            slidesToShow: 1.2,
                            arrows: true,
                        }
                    }
                ]
            });
        }

        if ($('.products-loop-section.is-carousel .products').length) {
            $('.products-loop-section.is-carousel').each(function() {
                const $categoryProductsLoop = $(this);
                const categoryCarouselColumns = String($categoryProductsLoop.data('carousel-columns') || 'three');
                const categoryDesktopSlidesToShow = categoryCarouselColumns === 'two' ? 2 : 3;
                const $products = $categoryProductsLoop.find('.products');

                function syncCategoryCarouselControls(slick) {
                    const canScroll = slick.slideCount > slick.options.slidesToShow;
                    $products.toggleClass('is-static', !canScroll);

                    if (!$products.hasClass('slick-initialized') || $products.data('syncingControls')) {
                        return;
                    }

                    if (slick.options.infinite === canScroll && slick.options.swipe === canScroll) {
                        return;
                    }

                    $products.data('syncingControls', true);
                    $products.slick('slickSetOption', 'infinite', canScroll, false);
                    $products.slick('slickSetOption', 'swipe', canScroll, false);
                    $products.slick('slickSetOption', 'draggable', canScroll, true);
                    $products.data('syncingControls', false);
                }

                // Slick assigns the instance after the init event, so option updates wait one tick.
                $products.on('init breakpoint reInit', function(event, slick) {
                    $products.toggleClass('is-static', !(slick.slideCount > slick.options.slidesToShow));
                    window.setTimeout(function() {
                        syncCategoryCarouselControls(slick);
                    }, 0);
                });

                $products.slick({
                    slidesToShow: categoryDesktopSlidesToShow,
                    speed: 700,
                    arrows: true,
                    dots: true,
                    prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div></div>',
                    nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                    centerPadding: '0px',
                    centerMode: false,
                    cssEase: 'ease',
                    infinite: true,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 976,
                            settings: {
                                slidesToShow: 1.1,
                                infinite: true,
                            }
                        }
                    ]
                });
            });
        }

        if ($('.cutting-edge-slider').length) {
            $('.cutting-edge-slider').slick({
                infinite: true,
                focusOnSelect: true,
                slidesToShow: 3,
                speed: 500,
                arrows: true,
                dots: true,
                prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div>',
                nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                centerPadding: '0px',
                cssEase: 'ease',
                responsive: [
                    {
                        breakpoint: 1281,
                        settings: {
                            slidesToShow: 2.5,
                            centerMode: false,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2.2,
                            centerMode: false,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1.5,
                            centerMode: false,
                            infinite: false,
                        }
                    }
                ]
            });

            // Add dot limiting functionality for cutting-edge-slider
            const $cuttingEdgeSlider = $('.cutting-edge-slider');
            const totalSlides = $cuttingEdgeSlider.find('.slick-slide:not(.slick-cloned)').length;
            const dotsToShow = 5; // Show 5 dots at a time

            function updateCuttingEdgeSlidingDots(currentSlide) {
                // Only apply sliding dots on mobile/tablet (below 976px)
                if ($(window).width() > 976) {
                    // On desktop, show all dots
                    const $dots = $cuttingEdgeSlider.find('.slick-dots li');
                    $dots.show();
                    return;
                }

                const $dotsContainer = $cuttingEdgeSlider.find('.slick-dots');
                const $dots = $dotsContainer.find('li');

                if ($dots.length <= dotsToShow) {
                    // If we have fewer dots than the limit, show all
                    $dots.show();
                    return;
                }

                // Calculate the range of dots to show
                let startIndex = Math.max(0, currentSlide - Math.floor(dotsToShow / 2));
                const endIndex = Math.min(totalSlides - 1, startIndex + dotsToShow - 1);

                // Adjust start index if we're near the end
                if (endIndex === totalSlides - 1) {
                    startIndex = Math.max(0, endIndex - dotsToShow + 1);
                }

                // Hide all dots first
                $dots.hide();

                // Show only the dots in our window
                for (let i = startIndex; i <= endIndex; i++) {
                    $dots.eq(i).show();
                }

                // Add smooth transition
                $dotsContainer.css('transition', 'transform 0.3s ease');
            }

            // Initialize dots on slider init
            $cuttingEdgeSlider.on('init', function(event, slick) {
                updateCuttingEdgeSlidingDots(slick.currentSlide);
            });

            // Update dots when slide changes
            $cuttingEdgeSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                updateCuttingEdgeSlidingDots(nextSlide);
            });

            // Update dots on window resize
            $(window).on('resize', function() {
                updateCuttingEdgeSlidingDots($cuttingEdgeSlider.slick('slickCurrentSlide'));
            });
        }

        if ($('.accessories-slider').length) {
            const $accessoriesSlider = $('.accessories-slider');

            function equalizeAccessoryCards($slider) {
                const $cards = $slider.find('.slick-slide .accessory-card');
                $cards.css('height', '');

                if (window.innerWidth < 975) {
                    return;
                }

                let maxHeight = 0;
                $cards.each(function () {
                    maxHeight = Math.max(maxHeight, this.offsetHeight);
                });

                if (maxHeight > 0) {
                    $cards.css('height', maxHeight + 'px');
                }
            }

            $accessoriesSlider.on('setPosition', function () {
                equalizeAccessoryCards($(this));
            });

            $accessoriesSlider.slick({
                infinite: true,
                focusOnSelect: true,
                slidesToShow: 5,
                speed: 500,
                arrows: true,
                dots: true,
                prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div>',
                nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                centerPadding: '0px',
                cssEase: 'ease',
                responsive: [
                    {
                        breakpoint: 976,
                        settings: {
                            slidesToShow: 2.5,
                            arrows: false,
                            centerMode: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1.5,
                            arrows: false,
                            centerMode: false,
                        }
                    }
                ]
            });
        }

        if ($('.slick-recent-posts').length) {
            $('.slick-recent-posts').slick({
                infinite: false,
                focusOnSelect: true,
                slidesToShow: 3,
                speed: 500,
                arrows: true,
                dots: false,
                prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div>',
                nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                centerPadding: '0px',
                cssEase: 'ease',
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 2.5,
                            centerMode: false,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 976,
                        settings: {
                            slidesToShow: 2.2,
                            centerMode: false,
                            infinite: false,
                            dots: true,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1.2,
                            centerMode: false,
                            infinite: false,
                            dots: true,
                            arrows: false,
                        }
                    }
                ]
            });
        }

        if ($('.history-slider').length) {
            $('.history-slider').slick({
                infinite: false,
                focusOnSelect: true,
                slidesToShow: 4,
                speed: 500,
                arrows: true,
                dots: true,
                dotsClass: 'slick-dots history-dots',
                prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div>',
                nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                centerPadding: '0px',
                cssEase: 'ease',
                responsive: [
                    {
                        breakpoint: 976,
                        settings: {
                            slidesToShow: 3,
                            centerMode: false,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 778,
                        settings: {
                            slidesToShow: 2,
                            centerMode: false,
                            infinite: false,
                        }
                    }
                    ,
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            centerMode: false,
                            infinite: false,
                        }
                    }
                    ,
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            centerMode: false,
                            infinite: false,
                        }
                    }
                ]
            });

            // Sliding dot navigation
            const $slider = $('.history-slider');
            const totalSlides = $slider.find('.slick-slide').length;
            const dotsToShow = 5; // Show 5 dots at a time

            function updateSlidingDots(currentSlide) {
                // Only apply sliding dots on mobile/tablet (below 976px)
                if ($(window).width() > 976) {
                    // On desktop, show all dots
                    const $dots = $slider.find('.slick-dots li');
                    $dots.show();
                    return;
                }

                const $dotsContainer = $slider.find('.slick-dots');
                const $dots = $dotsContainer.find('li');

                if ($dots.length <= dotsToShow) {
                    // If we have fewer dots than the limit, show all
                    $dots.show();
                    return;
                }

                // Calculate the range of dots to show
                let startIndex = Math.max(0, currentSlide - Math.floor(dotsToShow / 2));
                const endIndex = Math.min(totalSlides - 1, startIndex + dotsToShow - 1);

                // Adjust start index if we're near the end
                if (endIndex === totalSlides - 1) {
                    startIndex = Math.max(0, endIndex - dotsToShow + 1);
                }

                // Hide all dots first
                $dots.hide();

                // Show only the dots in our window
                for (let i = startIndex; i <= endIndex; i++) {
                    $dots.eq(i).show();
                }

                // Add smooth transition
                $dotsContainer.css('transition', 'transform 0.3s ease');
            }

            // Initialize dots on slider init
            $slider.on('init', function(event, slick) {
                updateSlidingDots(slick.currentSlide);
            });

            // Update dots when slide changes
            $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                updateSlidingDots(nextSlide);
            });

            // Update dots on window resize
            $(window).on('resize', function() {
                updateSlidingDots($slider.slick('slickCurrentSlide'));
            });
        }

        if ($('.leadership-slider').length) {
            const $leadershipSlider = $('.leadership-slider');
            const leadershipDesktopColumnMap = {
                'three-cols': 3,
                'four-cols': 4,
                'five-cols': 5,
                'six-cols': 6
            };
            const leadershipDesktopColumnsValue = String($leadershipSlider.data('desktop-columns') || 'four-cols');
            const leadershipDesktopSlidesToShow = leadershipDesktopColumnMap[leadershipDesktopColumnsValue] || 4;
            const leadershipLargeSlidesToShowMap = {
                'five-cols': 4,
                'six-cols': 3
            };
            const leadershipLargeSlidesToShow = leadershipLargeSlidesToShowMap[leadershipDesktopColumnsValue];
            const leadershipResponsiveSettings = [];

            // For 5/6 desktop column layouts, reduce earlier on large screens instead of waiting for tablet.
            if (leadershipLargeSlidesToShow) {
                leadershipResponsiveSettings.push({
                    breakpoint: 1450,
                    settings: {
                        slidesToShow: leadershipLargeSlidesToShow,
                        centerMode: false,
                        infinite: false
                    }
                });
            }

            leadershipResponsiveSettings.push(
                {
                    breakpoint: 778,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                        infinite: false,
                        arrows: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        infinite: false,
                        arrows: true
                    }
                },
                {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        infinite: false,
                        arrows: true,
                        adaptiveHeight: true
                    }
                }
            );

            $leadershipSlider.slick({
                infinite: false,
                focusOnSelect: false,
                slidesToShow: leadershipDesktopSlidesToShow,
                speed: 500,
                arrows: true,
                dots: true,
                dotsClass: 'slick-dots leadership-dots',
                prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div>',
                nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                centerPadding: '0px',
                cssEase: 'ease',
                responsive: leadershipResponsiveSettings
            });

            // Sliding dot navigation for leadership slider
            const leadershipTotalSlides = $leadershipSlider.find('.slick-slide').length;
            const leadershipDotsToShow = 5; // Show 5 dots at a time

            function updateLeadershipSlidingDots(currentSlide) {
                // Only apply sliding dots on mobile/tablet (below 976px)
                if ($(window).width() > 976) {
                    // On desktop, show all dots
                    const $dots = $leadershipSlider.find('.slick-dots li');
                    $dots.show();
                    return;
                }

                const $dotsContainer = $leadershipSlider.find('.slick-dots');
                const $dots = $dotsContainer.find('li');

                if ($dots.length <= leadershipDotsToShow) {
                    // If we have fewer dots than the limit, show all
                    $dots.show();
                    return;
                }

                // Calculate the range of dots to show
                let startIndex = Math.max(0, currentSlide - Math.floor(leadershipDotsToShow / 2));
                const endIndex = Math.min(leadershipTotalSlides - 1, startIndex + leadershipDotsToShow - 1);

                // Adjust start index if we're near the end
                if (endIndex === leadershipTotalSlides - 1) {
                    startIndex = Math.max(0, endIndex - leadershipDotsToShow + 1);
                }

                // Hide all dots first
                $dots.hide();

                // Show only the dots in our window
                for (let i = startIndex; i <= endIndex; i++) {
                    $dots.eq(i).show();
                }

                // Add smooth transition
                $dotsContainer.css('transition', 'transform 0.3s ease');
            }

            // Initialize dots on slider init
            $leadershipSlider.on('init', function(event, slick) {
                updateLeadershipSlidingDots(slick.currentSlide);
            });

            // Update dots when slide changes
            $leadershipSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                updateLeadershipSlidingDots(nextSlide);
            });

            // Update dots on window resize
            $(window).on('resize', function() {
                updateLeadershipSlidingDots($leadershipSlider.slick('slickCurrentSlide'));
            });
        }

        if ($('.office-slider').length) {
            $('.office-slider').slick({
                infinite: true,
                focusOnSelect: true,
                slidesToShow: 3,
                speed: 500,
                arrows: true,
                dots: true,
                dotsClass: 'slick-dots office-dots',
                accessibility: false,
                prevArrow: '<div class="wp-block-button prevNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M16.8136 32.6889L19.6777 29.8248L6.40597 16.553L19.6777 3.28123L16.8136 0.417114L0.677734 16.553L16.8136 32.6889Z" fill="white"/> </svg></div>',
                nextArrow: '<div class="wp-block-button nextNav"><div class="wp-element-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="33" viewBox="0 0 20 33" fill="none"> <path d="M3.36412 32.6889L0.5 29.8248L13.7718 16.553L0.5 3.28123L3.36412 0.417114L19.5 16.553L3.36412 32.6889Z" fill="white"/> </svg></div></div>',
                centerPadding: '0px',
                centerMode: false,
                cssEase: 'ease',
                responsive: [
                    {
                        breakpoint: 976,
                        settings: {
                            slidesToShow: 2,
                            infinite: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            infinite: false,
                            adaptiveHeight: true,
                        }
                    }
                ]
            });

            // Sliding dot navigation for office slider
            const $officeSlider = $('.office-slider');
            const officeTotalSlides = $officeSlider.find('.slick-slide').length;
            const officeDotsToShow = 5; // Show 5 dots at a time

            function updateOfficeSlidingDots(currentSlide) {
                // Only apply sliding dots on mobile/tablet (below 976px)
                if ($(window).width() > 976) {
                    // On desktop, show all dots
                    const $dots = $officeSlider.find('.slick-dots li');
                    $dots.show();
                    return;
                }

                const $dotsContainer = $officeSlider.find('.slick-dots');
                const $dots = $dotsContainer.find('li');

                if ($dots.length <= officeDotsToShow) {
                    // If we have fewer dots than the limit, show all
                    $dots.show();
                    return;
                }

                // Calculate the range of dots to show
                let startIndex = Math.max(0, currentSlide - Math.floor(officeDotsToShow / 2));
                const endIndex = Math.min(officeTotalSlides - 1, startIndex + officeDotsToShow - 1);

                // Adjust start index if we're near the end
                if (endIndex === officeTotalSlides - 1) {
                    startIndex = Math.max(0, endIndex - officeDotsToShow + 1);
                }

                // Hide all dots first
                $dots.hide();

                // Show only the dots in our window
                for (let i = startIndex; i <= endIndex; i++) {
                    $dots.eq(i).show();
                }

                // Add smooth transition
                $dotsContainer.css('transition', 'transform 0.3s ease');
            }

            // Initialize dots on slider init
            $officeSlider.on('init', function(event, slick) {
                updateOfficeSlidingDots(slick.currentSlide);
            });

            // Update dots when slide changes
            $officeSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                updateOfficeSlidingDots(nextSlide);
            });

            // Update dots on window resize
            $(window).on('resize', function() {
                updateOfficeSlidingDots($officeSlider.slick('slickCurrentSlide'));
            });
        }
    }

    /** Function to check and initialize slick on window resize and initial load */
    initializeSlickSlider();

    /** Initializing Slick Slider in Admin */
	if ( typeof acf !== 'undefined' ) {
		acf.addAction( 'load', function() {
			initializeSlickSlider();
		} );
	}
});

jQuery(document).ready(function($) {
    // Accordion functionality for mobile
    $('.accordion-opener').click(function() {
        const $panel = $(this).next('.tab-panel'); // Get the corresponding tab content
        const isOpen = $panel.hasClass('active'); // Check if it's already open

        if (!isOpen) {
            // Close all panels first
            $('.tab-panel').removeClass('active').css({
                'max-height': '0',
                'opacity': '0'
            });
            $('.accordion-opener').removeClass('opened').addClass('closed');

            // Then open the clicked panel smoothly
            if ($panel.length && $panel[0]) {
                $panel.addClass('active').css({
                    'max-height': $panel[0].scrollHeight + 'px',
                    'opacity': '1'
                });
            }
            $(this).removeClass('closed').addClass('opened');
        } else {
            // If it's already open, just close it smoothly
            $panel.removeClass('active').css({
                'max-height': '0',
                'opacity': '0'
            });
            $(this).removeClass('opened').addClass('closed');
        }
    });

    // Tabs functionality for desktop
    $('.tabs .tab').click(function() {
        const tab_id = $(this).data('tab');

        $('.tabs .tab').removeClass('active');
        $('.tab-panel').removeClass('active').css({
            'max-height': '0',
            'opacity': '0'
        });

        $(this).addClass('active');
        const $activePanel = $('#' + tab_id);
        if ($activePanel.length && $activePanel[0]) {
            $activePanel.addClass('active').css({
                'max-height': $activePanel[0].scrollHeight + 'px',
                'opacity': '1'
            });
        }
    });

    // Make the first tab active by default
    $('.tabs .tab').first().addClass('active');
    const $firstPanel = $('.tab-panel').first();
    if ($firstPanel.length && $firstPanel[0]) {
        $firstPanel.addClass('active').css({
            'max-height': $firstPanel[0].scrollHeight + 'px',
            'opacity': '1'
        });
    }

    // Initialize accordion opener classes on page load
    $('.accordion-opener').each(function() {
        const $panel = $(this).next('.tab-panel');
        if ($panel.hasClass('active')) {
            $(this).addClass('opened').removeClass('closed');
        } else {
            $(this).addClass('closed').removeClass('opened');
        }
    });
});

jQuery(document).ready(function($) {
    // Open the review modal
    $('#write-review').on('click', function() {
        $('#review-modal').fadeIn();
    });

    // Close the review modal
    $('#close-review-modal').on('click', function() {
        $('#review-modal').fadeOut();
    });
});

jQuery(document).ready(function($){
    // Increase quantity - works on both product pages and cart page
    $('.quantity-plus').on('click', function(){
        const $button = $(this);
        // Find the quantity input within the same quantity-buttons container
        const $quantityInput = $button.siblings('.qty, input[type="number"]');

        if ($quantityInput.length) {
            const currentValue = parseInt($quantityInput.val());
            if (!isNaN(currentValue)) {
                $quantityInput.val(currentValue + 1).trigger('change');
            }
        }
    });

    // Decrease quantity - works on both product pages and cart page
    $('.quantity-minus').on('click', function(){
        const $button = $(this);
        // Find the quantity input within the same quantity-buttons container
        const $quantityInput = $button.siblings('.qty, input[type="number"]');

        if ($quantityInput.length) {
            const currentValue = parseInt($quantityInput.val());
            if (!isNaN(currentValue) && currentValue > 1) {
                $quantityInput.val(currentValue - 1).trigger('change');
            }
        }
    });
});

jQuery(window).on('load', function () {
    const $mainGallery = jQuery('.woocommerce-product-gallery__wrapper');
    const $thumbGallery = jQuery('.flex-control-nav.flex-control-thumbs');

    function refreshProductGalleries() {
        if ($mainGallery.hasClass('slick-initialized')) {
            $mainGallery.slick('setPosition');
        }

        if ($thumbGallery.hasClass('slick-initialized')) {
            $thumbGallery.slick('setPosition');
        }
    }

    // Initialize the Main Gallery (this should be initialized first)
    if ($mainGallery.length) {
        $mainGallery.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: false,
            dots: false,
            fade: true,
            centerMode: false,
            centerPadding: '0px',
            infinite: false,
            cssEase: 'linear',
        }).on('afterChange', function (event, slick, currentSlide) {
            // Sync thumbnail gallery with main product gallery
            const index = currentSlide;
            if ($thumbGallery.hasClass('slick-initialized')) {
                $thumbGallery.slick('slickGoTo', index);
            }
        });

        // Recompute dimensions when layout changes (tablet/desktop gallery swap).
        jQuery(window).on('resize orientationchange', function () {
            window.requestAnimationFrame(refreshProductGalleries);
        });
    }

    // Initialize Thumbnail Gallery with a slight delay to ensure images are fully loaded
    setTimeout(function () {
        if ($thumbGallery.length) {
            $thumbGallery.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                centerMode: false,
                focusOnSelect: true,
                infinite: true,
                variableWidth: false,
                vertical: true,
                verticalSwiping: true,
                centerPadding: '0px',
                cssEase: 'linear',
                prevArrow: '<div class="prevNav"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="24" viewBox="0 0 15 24" fill="none"> <path d="M12.3996 23.8331L14.5 21.7327L4.76737 12.0001L14.5 2.26747L12.3996 0.167114L0.566667 12.0001L12.3996 23.8331Z" fill="#666666"/> </svg></div>',
                nextArrow: '<div class="nextNav"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="24" viewBox="0 0 15 24" fill="none"> <path d="M2.60035 23.8331L0.5 21.7327L10.2326 12.0001L0.5 2.26747L2.60035 0.167114L14.4333 12.0001L2.60035 23.8331Z" fill="#666666"/> </svg></div>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                        }
                    }
                ]
            }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                // Sync main gallery with thumbnail selection
                $mainGallery.slick('slickGoTo', nextSlide);
            });

            // Thumbs init changes available width for the main gallery — re-measure once.
            window.requestAnimationFrame(refreshProductGalleries);
        }
    }, 100);
});

// jQuery(document).ready(function($) {
//     // Save the initial price HTML to restore it if needed
//     const defaultPriceHtml = $('.price-container').html();

//     // When a variation is selected
//     $('form.variations_form').on('show_variation', function(event, variation) {
//         if (variation.price_html) {
//             // If a variation price exists, update the price
//             $('.price-container').html(variation.price_html); // Use WooCommerce's variation price HTML
//         } else if (variation.regular_price) {
//             // If there's no sale price, show the regular price
//             $('.price-container').html('<span class="price">' + variation.regular_price + '</span>');
//         } else {
//             // If no price at all, show "Not Available"
//             $('.price-container').html('<span class="price">Not Available</span>');
//         }
//     });

//     // When no variation is selected (reset the price)
//     $('form.variations_form').on('reset_data', function() {
//         $('.price-container').html(defaultPriceHtml); // Restore default price (if no variation is selected)
//     });
// });

jQuery(document).ready(function($) {
    $('.cr-avatar').each(function() {
      $(this).attr('src', '/wp-content/themes/ct-theme/assets/img/default-avatar.png');
    });
});

jQuery(document).ready(function($) {
    // Cache elements
    const $container = $('.product-default-flex');
    const $shiftDiv = $('.shift-on-mobile');
    const $socialDiv = $('.social-sharing');

    // Cache original parents to restore on desktop
    const $originalShiftParent = $('.product-summary');
    const $originalSocialParent = $('.gallery-section');

    function moveElements() {
        if ($(window).width() <= 976) {
            // Move .shift-on-mobile to the start of .product-default-flex
            if ($shiftDiv.parent()[0] !== $container[0]) {
                $shiftDiv.prependTo($container);
            }

            // Move .social-sharing to the end of .product-default-flex
            if ($socialDiv.parent()[0] !== $container[0]) {
                $socialDiv.appendTo($container);
            }
        } else {
            // Move back .shift-on-mobile to start of .product-summary
            if ($shiftDiv.parent()[0] !== $originalShiftParent[0]) {
                $shiftDiv.prependTo($originalShiftParent);
            }

            // Move back .social-sharing to end of .gallery-section
            if ($socialDiv.parent()[0] !== $originalSocialParent[0]) {
                $socialDiv.appendTo($originalSocialParent);
            }
        }
    }

    // Run on load and resize
    moveElements();
    $(window).resize(moveElements);
});

jQuery(document).ready(function($) {
    // Move order_review_heading inside order_review on checkout page
    if ($('.page').hasClass('woocommerce-checkout') && $('#order_review_heading').length && $('#order_review').length) {
        $('#order_review_heading').prependTo('#order_review');
    }
});

jQuery(document).ready(function($) {
    const frenchStreetTypes = {
        rue: 'Street',
        chemin: 'Road',
        croissant: 'Crescent',
        allee: 'Lane',
        'allée': 'Lane',
        impasse: 'Lane',
        montee: 'Road',
        'montée': 'Road',
        terrasse: 'Terrace',
        promenade: 'Drive',
        cercle: 'Circle',
        boulevard: 'Boulevard',
        avenue: 'Avenue'
    };
    const leftoverTypeMap = {
        street: 'Street',
        st: 'Street',
        road: 'Road',
        rd: 'Road',
        avenue: 'Avenue',
        ave: 'Avenue',
        boulevard: 'Boulevard',
        blvd: 'Boulevard',
        drive: 'Drive',
        dr: 'Drive',
        crescent: 'Crescent',
        cres: 'Crescent',
        lane: 'Lane',
        ln: 'Lane',
        terrace: 'Terrace',
        terr: 'Terrace',
        circle: 'Circle',
        cir: 'Circle',
        court: 'Court',
        crt: 'Court',
        way: 'Way'
    };

    function foldType(value) {
        return String(value || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\./g, '');
    }

    function shouldAnglicize($country, $state) {
        if (String($country.val() || '').toUpperCase() !== 'CA') {
            return false;
        }
        const state = String($state.val() || '').toUpperCase().replace(/[^A-Z]/g, '');
        return state !== 'QC';
    }

    function normalizeLines(line1, line2) {
        let address1 = String(line1 || '').trim();
        let address2 = String(line2 || '').trim();
        const typeAlt = Object.keys(frenchStreetTypes).join('|');
        const typeFirst = new RegExp('^((?:#?\\d+[A-Za-z]?(?:\\s*-\\s*|\\s+))?\\d+[A-Za-z]?)\\s+(' + typeAlt + ')\\s+(.+)$', 'i');
        const match = address1.match(typeFirst);

        if (match) {
            const english = frenchStreetTypes[foldType(match[2])] || match[2];
            let name = match[3].trim();
            if (!new RegExp('\\b' + english + '$', 'i').test(name)) {
                name += ' ' + english;
            }
            address1 = (match[1] + ' ' + name).trim();
        }

        const leftover = address2.match(/^(Street|St\.?|Road|Rd\.?|Avenue|Ave\.?|Boulevard|Blvd\.?|Drive|Dr\.?|Crescent|Cres\.?|Lane|Ln\.?|Terrace|Terr\.?|Circle|Cir\.?|Court|Crt\.?|Way)\s+(North|South|East|West|Northwest|Northeast|Southwest|Southeast|N|S|E|W|NW|NE|SW|SE)\.?$/i);
        if (leftover) {
            const englishType = leftoverTypeMap[foldType(leftover[1])] || leftover[1];
            if (new RegExp('\\b' + englishType + '$', 'i').test(address1)) {
                address1 += ' ' + leftover[2];
            } else {
                address1 += ' ' + englishType + ' ' + leftover[2];
            }
            address2 = '';
        }

        return { address1, address2 };
    }

    let normalizing = false;

    function normalizePrefix(prefix) {
        const $country = $('#' + prefix + '_country');
        const $state = $('#' + prefix + '_state');
        const $line1 = $('#' + prefix + '_address_1');
        const $line2 = $('#' + prefix + '_address_2');
        if (!$line1.length || !shouldAnglicize($country, $state)) {
            return;
        }

        const next = normalizeLines($line1.val(), $line2.val());
        if (next.address1 !== String($line1.val() || '') || next.address2 !== String($line2.val() || '')) {
            normalizing = true;
            $line1.val(next.address1).trigger('change');
            $line2.val(next.address2).trigger('change');
            normalizing = false;
        }
    }

    function normalizeCheckoutAddresses() {
        normalizePrefix('billing');
        normalizePrefix('shipping');
    }

    if ($('#billing_address_1, #shipping_address_1').length) {
        $(document.body).on('change blur', '#billing_address_1, #billing_address_2, #billing_state, #billing_country, #shipping_address_1, #shipping_address_2, #shipping_state, #shipping_country', function() {
            if (!normalizing) {
                normalizeCheckoutAddresses();
            }
        });
        $(document.body).on('updated_checkout', normalizeCheckoutAddresses);
        setTimeout(normalizeCheckoutAddresses, 500);
    }
});

jQuery(document).ready(function($) {
    // Leadership bio read more/show less functionality
    $('.bio-toggle').on('click', function() {
        const $button = $(this);
        const $bioContainer = $button.closest('.leadership-bio-container');
        const $bioShort = $bioContainer.find('.bio-short');
        const $bioFull = $bioContainer.find('.bio-full');
        const currentAction = $button.data('action');

        if (currentAction === 'read-more') {
            // Show full bio
            $bioShort.hide();
            $bioFull.show();
            $button.text('Show less').data('action', 'show-less');
        } else {
            // Show short bio
            $bioShort.show();
            $bioFull.hide();
            $button.text('Read more').data('action', 'read-more');
        }
    });
});

jQuery(document).ready(function($) {
    // Sticky header functionality
    const $header = $('.site-header');
    const $body = $('body');
    const $page = $('#page');

    // Check if header is transparent (class is on #page, not body)
    const isTransparentHeader = $page.hasClass('transparent-header') || $body.hasClass('transparent-header');

    function markAppPageBanner() {
        if (document.querySelector('.ct-app-banner')) {
            return;
        }

        const isAppPage = /\/app\/?$/.test(window.location.pathname) ||
            !!document.querySelector('article.post-2919');
        if (!isAppPage) {
            return;
        }

        const banner = document.querySelector('.entry-content > .wp-block-uagb-container.alignfull');
        if (banner) {
            banner.classList.add('ct-app-banner');
        }
    }

    // Promo bar height only. The stylesheet calc uses this variable.
    // Do not set height or min-height here; that inline size overrides the mobile rules.
    function syncHomeBannerTopBarVar() {
        const banners = document.querySelectorAll('.ct-home-banner');
        if (!banners.length) {
            return;
        }

        const topBar = document.querySelector('.ct-top-bar');
        const topBarHeight = (topBar && topBar.offsetParent !== null)
            ? topBar.offsetHeight
            : 0;

        banners.forEach(function(banner) {
            banner.style.setProperty('--ct-top-bar-height', topBarHeight + 'px');
        });
    }

    // Size the App banner from its current top edge to the bottom of the viewport.
    // Homepage hero stays on stylesheet sizing so mobile rules are not overridden.
    function syncHomeBannerTopBarHeight() {
        markAppPageBanner();

        const banners = document.querySelectorAll('.ct-app-banner');
        if (!banners.length) {
            return;
        }

        banners.forEach(function(banner) {
            // Clear previous fixed height so measurement uses natural position
            banner.style.removeProperty('height');
            banner.style.removeProperty('min-height');

            const topBar = document.querySelector('.ct-top-bar');
            const topBarHeight = (topBar && topBar.offsetParent !== null)
                ? topBar.offsetHeight
                : 0;
            const bannerTop = banner.getBoundingClientRect().top;
            const chromeHeight = banner.classList.contains('ct-app-banner')
                ? Math.max(0, Math.round(bannerTop))
                : topBarHeight;
            banner.style.setProperty('--ct-top-bar-height', chromeHeight + 'px');

            // After layout, fill exactly from banner top → viewport bottom (accounts for top bar + header overlap)
            const bannerHeight = Math.max(0, Math.round(window.innerHeight - bannerTop));
            banner.style.setProperty('min-height', bannerHeight + 'px', 'important');
            banner.style.setProperty('height', bannerHeight + 'px', 'important');
        });
    }

    // Category, product, page, and blog sticky banners: fill from document position to the bottom of the first screen
    function syncArchiveBannerHeight() {
        const banners = document.querySelectorAll('.ct-archive-banner, .ct-product-banner, .ct-page-banner, .ct-blog-banner');
        if (!banners.length) {
            return;
        }

        banners.forEach(function(banner) {
            banner.style.height = '';
            banner.style.minHeight = '';

            const chromeHeight = Math.max(0, Math.round(banner.getBoundingClientRect().top + window.scrollY));
            banner.style.setProperty('--ct-chrome-height', chromeHeight + 'px');

            const bannerHeight = Math.max(0, Math.round(window.innerHeight - chromeHeight));
            banner.style.minHeight = bannerHeight + 'px';
            banner.style.height = bannerHeight + 'px';
        });
    }

    // Keep compare, news, and category product carousels at least one viewport tall on desktop/tablet
    function syncHomeCompareSectionHeight() {
        const sections = document.querySelectorAll('.ct-home-compare, .ct-home-news, .products-loop-section.is-carousel');
        if (!sections.length) {
            return;
        }

        sections.forEach(function(section) {
            if (window.innerWidth <= 767) {
                section.style.minHeight = '';
                section.style.height = '';
                return;
            }

            section.style.height = '';
            section.style.minHeight = window.innerHeight + 'px';
        });
    }

    function syncHomeViewportSections() {
        syncHomeBannerTopBarVar();
        syncHomeBannerTopBarHeight();
        syncArchiveBannerHeight();
        syncHomeCompareSectionHeight();
    }

    function handleStickyHeader() {
        const scrollTop = $(window).scrollTop();
        const headerHeight = $header.outerHeight();

        // Add sticky class when scrolled past header height
        if (scrollTop > headerHeight) {
            $header.addClass('is-sticky');

            // Add blue background for transparent headers
            if (isTransparentHeader) {
                $header.addClass('sticky-blue-bg');
            }
        } else {
            $header.removeClass('is-sticky sticky-blue-bg');
        }
    }

    // Run on scroll and resize
    $(window).on('scroll', handleStickyHeader);
    $(window).on('resize', function() {
        handleStickyHeader();
        syncHomeViewportSections();
    });

    // Run on page load
    handleStickyHeader();
    syncHomeViewportSections();
    // Re-run after fonts/images/layout settle
    $(window).on('load', syncHomeViewportSections);

    $("#jqvmap1_us_pin").css('transform', 'translate(-40%, 100%)');
    let usLoc2 = $("#jqvmap1_us_pin").clone();
    usLoc2.removeAttr('id');
    usLoc2.attr('id', 'jqvmap1_us2_pin')
    $("#jqvmap1_us_pin").after(usLoc2)
    $("#jqvmap1_us2_pin").removeClass('active').css('transform', 'translate(250%, 200%)');
});

// Tabs with Image Zoom Block JavaScript
jQuery(document).ready(function($) {
    // Initialize all tabs with zoom blocks
    $('.tabs-with-zoom-block').each(function() {
        const $block = $(this);
        initializeTabsWithZoom($block);
    });
    
    function initializeTabsWithZoom($block) {
        // Desktop Tabs Functionality
        const $tabButtons = $block.find('.tab-button');
        const $imageContainer = $block.find('.tabs-image-side .image-zoom-container');
        
        $tabButtons.on('click', function() {
            const $clickedButton = $(this);
            const tabIndex = $clickedButton.data('tab-index');
            
            // Remove active from all tabs
            $tabButtons.removeClass('active').attr('aria-selected', 'false');
            
            // Add active to clicked tab
            $clickedButton.addClass('active').attr('aria-selected', 'true');
            
            // Update the image and zoom areas based on the selected tab
            updateTabImage($block, tabIndex);
            
            // Update the tab content panels
            updateTabContent($block, tabIndex);
        });
        
        // Mobile Accordion Functionality
        const $accordionHeaders = $block.find('.accordion-header');
        const $accordionBodies = $block.find('.accordion-body');
        
        $accordionHeaders.on('click', function() {
            const $clickedHeader = $(this);
            const accordionIndex = $clickedHeader.data('accordion-index');
            const isActive = $clickedHeader.hasClass('active');
            
            if (isActive) {
                // Close the clicked accordion
                $clickedHeader.removeClass('active').attr('aria-expanded', 'false');
                $accordionBodies.eq(accordionIndex).removeClass('active');
            } else {
                // Close all accordions first
                $accordionHeaders.removeClass('active').attr('aria-expanded', 'false');
                $accordionBodies.removeClass('active');
                
                // Open the clicked accordion
                $clickedHeader.addClass('active').attr('aria-expanded', 'true');
                $accordionBodies.eq(accordionIndex).addClass('active');
            }
        });
        
        // Image Zoom Functionality
        initializeImageZoom($block);
    }
    
    function updateTabImage($block, tabIndex) {
        // Get the tab data from the accordion items (they contain the same data)
        const $accordionItems = $block.find('.accordion-item');
        const $targetItem = $accordionItems.eq(tabIndex);
        
        if ($targetItem.length) {
            const $targetImageContainer = $targetItem.find('.image-zoom-container');
            const $mainImageContainer = $block.find('.tabs-image-side .image-zoom-container');
            
            if ($targetImageContainer.length && $mainImageContainer.length) {
                // Clone the image and zoom icons from the accordion item
                const $newImage = $targetImageContainer.find('img').clone();
                const $newZoomIcons = $targetImageContainer.find('.zoom-icon').clone();
                
                // Update the main image container
                $mainImageContainer.find('img').replaceWith($newImage);
                $mainImageContainer.find('.zoom-icon').remove();
                $mainImageContainer.append($newZoomIcons);
                
                // Reinitialize image zoom for the new content
                initializeImageZoom($block);
            }
        }
    }
    
    function updateTabContent($block, tabIndex) {
        // Get all tab panels
        const $tabPanels = $block.find('.tab-panel');
        
        // Remove active class from all panels
        $tabPanels.removeClass('active');
        
        // Add active class to the selected panel
        $tabPanels.eq(tabIndex).addClass('active');
    }
    
    function initializeImageZoom($block) {
        $block.find('.image-zoom-container').each(function() {
            const $container = $(this);
            const $img = $container.find('img');
            const $zoomIcons = $container.find('.zoom-icon');
            let isZoomed = false;
            let currentZoomIcon = null;
            
            // Click on zoom icon
            $zoomIcons.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const $clickedIcon = $(this);
                
                if (!isZoomed || currentZoomIcon !== $clickedIcon[0]) {
                    // Zoom in to specific area
                    $container.addClass('zoomed');
                    isZoomed = true;
                    currentZoomIcon = $clickedIcon[0];
                    
                    // Get icon position as percentages from style attribute
                    const iconStyle = $clickedIcon.attr('style');
                    const topMatch = iconStyle.match(/top:\s*([0-9.]+)%/);
                    const leftMatch = iconStyle.match(/left:\s*([0-9.]+)%/);
                    
                    const iconTop = topMatch ? parseFloat(topMatch[1]) : 50;
                    const iconLeft = leftMatch ? parseFloat(leftMatch[1]) : 50;
                    
                    // Zoom to the specific area where the icon is located
                    $img.css({
                        'transform': 'scale(2)',
                        'transform-origin': `${iconLeft}% ${iconTop}%`
                    });
                } else {
                    // Zoom out
                    $container.removeClass('zoomed');
                    isZoomed = false;
                    currentZoomIcon = null;
                    $img.css({
                        'transform': 'scale(1)',
                        'transform-origin': 'center center'
                    });
                }
            });
            
            // Click on image to zoom out
            $img.on('click', function(e) {
                if (isZoomed) {
                    e.preventDefault();
                    e.stopPropagation();
                    $container.removeClass('zoomed');
                    isZoomed = false;
                    currentZoomIcon = null;
                    $img.css({
                        'transform': 'scale(1)',
                        'transform-origin': 'center center'
                    });
                }
            });
        });
    }
});

// Intercom Chat Trigger Functionality
jQuery(document).ready(function($) {
    // Function to open Intercom chat
    function openIntercomChat() {
        // Check if Intercom is loaded
        if (typeof window.Intercom !== 'undefined') {
            // Open the Intercom messenger
            window.Intercom('show');
        } else if (typeof window.IntercomApp !== 'undefined') {
            // Alternative method for Intercom
            window.IntercomApp('show');
        } else {
            // Fallback: try to find and click the Intercom launcher button
            const intercomLauncher = document.querySelector('.intercom-launcher-frame') || 
                                   document.querySelector('[data-intercom-frame="true"]') ||
                                   document.querySelector('#intercom-container .intercom-launcher-frame') ||
                                   document.querySelector('.intercom-app iframe[title*="Intercom"]');
            
            if (intercomLauncher) {
                // Try to click the launcher iframe
                intercomLauncher.click();
            } else {
                // Try to find any clickable Intercom element
                const intercomContainer = document.querySelector('#intercom-container');
                if (intercomContainer) {
                    // Look for any clickable elements within Intercom container
                    const clickableElements = intercomContainer.querySelectorAll('iframe, button, div[role="dialog"]');
                    if (clickableElements.length > 0) {
                        clickableElements[0].click();
                    } else {
                        console.log('Intercom chat launcher not found. Please ensure Intercom is properly integrated.');
                    }
                } else {
                    console.log('Intercom container not found. Please ensure Intercom is properly integrated.');
                }
            }
        }
    }
    
    // Add click event to elements with the class 'intercom-chat-trigger' (keeping old class for backward compatibility)
    $(document).on('click', '.hubspot-chat-trigger, .intercom-chat-trigger', function(e) {
        e.preventDefault();
        openIntercomChat();
    });
    
    // Also support data attributes for more flexibility
    $(document).on('click', '[data-hubspot-trigger="chat"], [data-intercom-trigger="chat"]', function(e) {
        e.preventDefault();
        openIntercomChat();
    });
});

// Move coupon form above review order section on checkout
// Wait for jQuery to be available
(function() {
    function waitForJQuery() {
        if (typeof jQuery !== 'undefined' && typeof jQuery.fn !== 'undefined') {
            jQuery(document).ready(function($) {
                // Only run on checkout page
                if ($('#site-wrapper').hasClass('woocommerce-checkout')) {
                    // Function to move coupon form
                    function moveCouponForm() {
                        // Find the existing coupon form
                        let $couponForm = $('.woocommerce-form-coupon');
                        
                        if ($couponForm.length && $('.woocommerce-checkout-review-order').length) {
                            // Move the existing form to above review order section
                            $('.woocommerce-checkout-review-order').prepend($couponForm);
                        }
                    }
                    
                    // Function to remove AvaTax plain text node
                    function removeAvaTaxText() {
                        let $col2 = $('.woocommerce-checkout .col-2');
                        
                        if ($col2.length) {
                            // Get the DOM element (not jQuery object) to access text nodes
                            let col2Element = $col2[0];
                            
                            // Iterate through child nodes (including text nodes)
                            for (let i = 0; i < col2Element.childNodes.length; i++) {
                                let node = col2Element.childNodes[i];
                                
                                // Check if it's a text node and contains AvaTax message
                                if (node.nodeType === 3 && // Text node
                                    node.textContent && 
                                    node.textContent.indexOf('AvaTax uses this email') !== -1) {
                                    // Remove the text node
                                    node.remove();
                                    break;
                                }
                            }
                        }
                    }
                    
                    // (Removed) Place Order confirmation popup logic
                    
                    // Function to rename and move validate address button
                    function setupValidateButton() {
                        // Find the validate address button
                        let $validateButton = $('.wc_avatax_validate_address[data-address-type="billing"]');
                        
                        if ($validateButton.length) {
                            // Rename button text from "Validate Address" to "Confirm Address"
                            $validateButton.text('Confirm Address');
                            
                            // Find phone field container - look for form-row containing billing_phone
                            let $phoneField = $('#billing_phone').closest('.form-row');
                            
                            // If phone field doesn't exist, try finding it by label
                            if (!$phoneField.length) {
                                $phoneField = $('label[for="billing_phone"]').closest('.form-row');
                            }
                            
                            // Find email field container
                            let $emailField = $('#billing_email').closest('.form-row');
                            if (!$emailField.length) {
                                $emailField = $('label[for="billing_email"]').closest('.form-row');
                            }
                            
                            // If phone field exists, move button above it
                            if ($phoneField.length) {
                                $validateButton.detach().insertBefore($phoneField);
                            } 
                            // Otherwise, if email field exists, move button above it
                            else if ($emailField.length) {
                                $validateButton.detach().insertBefore($emailField);
                            }
                        }
                    }
                    
                    // Try to move immediately
                    moveCouponForm();
                    
                    // Remove AvaTax text immediately
                    removeAvaTaxText();
                    
                    // Setup validate button (rename and move)
                    setupValidateButton();
                    
                    // Also try after a delay to catch dynamically loaded fields
                    setTimeout(function() {
                        setupValidateButton();
                    }, 1000);
                    
                    // Also try on checkout updates
                    $(document.body).on('updated_checkout', function() {
                        moveCouponForm();
                        removeAvaTaxText();
                        setupValidateButton();
                    });
                }
                
                // Convert "Need help?" text to link in coupon error notices
                // This works on all pages (cart, checkout, etc.)
                function convertCouponHelpText() {
                    const contactUrl = (typeof ctTheme !== 'undefined' && ctTheme.contactUrl) ? ctTheme.contactUrl : '/contact/';
                    const $notices = $('.coupon-error-notice, .woocommerce-error, .woocommerce-error li');
                    if ($notices.length) {
                        $notices.each(function() {
                            const $this = $(this);
                            const text = $this.html();
                            
                            // Handle expired coupon messages - add "Need help?" if missing
                            if (text.toLowerCase().includes('has expired') && !text.includes('Need help?')) {
                                $this.html(text + ' <a href="' + contactUrl + '" target="_blank" rel="noopener noreferrer">Need help?</a>');
                                return;
                            }
                            
                            // Convert existing "Need help?" text to link if not already a link
                            if (text.includes('Need help?') && !text.includes('<a href')) {
                                $this.html(text.replace('Need help?', '<a href="' + contactUrl + '" target="_blank" rel="noopener noreferrer">Need help?</a>'));
                            }
                        });
                    }
                }
                
                // Convert coupon help text on page load
                convertCouponHelpText();
                
                // Run on cart and checkout AJAX updates
                $(document.body).on('updated_cart_totals updated_checkout', function() {
                    setTimeout(function() {
                        convertCouponHelpText();
                    }, 100);
                });
                
                // Use MutationObserver to catch dynamically added notices (especially on cart page)
                if (typeof MutationObserver !== 'undefined') {
                    const observer = new MutationObserver(function(mutations) {
                        convertCouponHelpText();
                    });
                    
                    // Observe the notices wrapper if it exists
                    const noticesWrapper = document.querySelector('.woocommerce-notices-wrapper');
                    if (noticesWrapper) {
                        observer.observe(noticesWrapper, {
                            childList: true,
                            subtree: true,
                            characterData: true
                        });
                    }
                    
                    // Also observe the body for when notices wrapper is added dynamically
                    const bodyObserver = new MutationObserver(function(mutations) {
                        mutations.forEach(function(mutation) {
                            mutation.addedNodes.forEach(function(node) {
                                if (node.nodeType === 1) { // Element node
                                    const wrapper = node.classList && node.classList.contains('woocommerce-notices-wrapper') 
                                        ? node 
                                        : node.querySelector && node.querySelector('.woocommerce-notices-wrapper');
                                    if (wrapper) {
                                        observer.observe(wrapper, {
                                            childList: true,
                                            subtree: true,
                                            characterData: true
                                        });
                                        convertCouponHelpText();
                                    }
                                }
                            });
                        });
                    });
                    
                    bodyObserver.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                }
            });
        } else {
            // jQuery not ready yet, try again in 100ms
            setTimeout(waitForJQuery, 100);
        }
    }
    
    // Start waiting for jQuery
    waitForJQuery();
})();

